<script>
    import Mobilebtn from '../mobilebtn.svelte';
    import {initializeGsapAnimation} from '../../utils.js';
    import {onMount} from 'svelte';

    let main;
    let text1;
    let text2;
    let text3;
    let scroll;
    let button;
    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation(main, text1, [{y: '-2vw', duration: 1}, {y: '2vw', duration: 1}], 3);
        initializeGsapAnimation(main, text2, [{y: '-2vw', duration: 1}, {y: '2vw', duration: 1}], 3);
        initializeGsapAnimation(main, text3, [{y: '-2vw', duration: 1}, {y: '2vw', duration: 1}], 3);
        initializeGsapAnimation(main, button, [{y: '-2.0309vw', duration: 1}, {y: '-14vw', duration: 1}], 3);
        initializeGsapAnimation(main, scroll, [{y: '-141vw', duration: 1}, {y: '-181vw', duration: 1}], 3);
}

</script>
<section>
    <div class="maindiv" bind:this={main}>
        <div class="info">
            <p class="text1" bind:this={text1}>Storytellers & Opus</p>
            <p class="heading" bind:this={text2}>PRODUCERS</p>
            <div bind:this={text3}>
                <p class="text2"  style="padding: 5.607vw 0vw 8.411vw;">
                    Nothing is more satisfying than seeing your production come to
                    life. In the future which we’re building, it isn't a year long
                    project around gathering a team, resources and equipment, rather
                    it’s an exercise in narrative.
                </p>
                <p class="text2"  style="font-weight: 700;">
                    Rather than waiting till the end to see the result, we start
                    with the production and the time is spent in tweaking and
                    refining the experience rather than hoping that the budget
                    lasts. Interested in buildlign that future alongside us?
                </p>
            </div>
        </div>
        <div>
            <div class="image" bind:this={scroll} style="">
                <img
                    src="/images/createmain/producer.png"
                    alt=""
                    width="100%"
                    height="100%"
                />
            </div>
        </div>
        <div class="btn" bind:this={button}>
          <div style="position: absolute;position: absolute;bottom: 45vw;left: 24vw;">
            <Mobilebtn width='56.308vw' text='Join Storytellers Governace Council' text2='(Producers Seat)' state ="Storyteller"/>
          </div>
        </div>
        <div class="arrowDown">
            <svg width="3.505vw" height="3.505vw" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.82 0.18L3.86 0.18L6.88 5.38L9.88 0.18L12.9 0.18L8.06 8.58L5.68 8.58L0.82 0.18Z" fill="black"/>
                </svg>
                
        </div>
    </div>
</section>

<style>
    .maindiv {
        position: relative;
        font-family: "Orbitron";
        z-index: 1;
        background-color: white;
        height: max(248vw, 114.81vh);
    }
    p {
        margin: 0;
    }
    .info {
        padding-top: max(87.383vw, 40.389vh);
        margin-left: 7.009vw;
        z-index: 2;
        position: relative;
    }
    .text1 {
        color: #000000;
        font-weight: 400;
        font-size: 2.336vw;
    }
    .heading {
        color: #a53bd6;
        font-weight: 900;
        font-size: 9.346vw;
    }
    .text2 {
        color: #000000;
        font-weight: 400;
        font-size: 2.804vw;
        line-height: 3.925vw;
        letter-spacing: 0.09em;
        width: 47.43vw;
    }
    .image {
        width: 42.757vw;
        position: absolute;
        top: max(85.514vw, 39.525vh);
        z-index: 0;
        right: 0;
    }
    .btn{
        position: absolute;
        z-index: 2;
        top: max(20.093vw, 9.287vh);
        width: 100%;
        height: 100%;

    }
    .arrowDown{
        position: absolute;
        bottom: max(19vw, 8.76vh);
        width: 3.505vw;
        height: 3.336vw;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
    }
</style>
